/* Offre blinds — The Sleep Vault. Mode MULTI-BLIND uniquement. Sans DPO depuis le 2026-10-29.

   Les choix (couleur, ouverture, dimensions en pouces ou en cm) sont dans VIRTUAL : mêmes textes et
   mêmes valeurs que l'ancien widget DPO, donc les configs sauvegardées restent valides. Le prix vient
   de priceFor() (formule d'origine de DPO, archivée dans lantre-du-sommeil/blinds-sans-dpo/config-dpo-archive.md).
   L'ajout au panier met, pour chaque window, la variante du produit caché vault-blackout-blinds-custom
   dont le prix = priceFor(window) (table data-prix-variantes), avec les mêmes propriétés de ligne
   qu'avant. Un seul appel /cart/add.js pour toutes les windows. Voir lantre-du-sommeil/blinds-sans-dpo/README.md. */
(function () {
  'use strict';

  // Persistance de la config (localStorage). 30 jours.
  var STORAGE_KEY = 'tsv-blinds-offer-cfg';
  var STORAGE_TTL = 30 * 24 * 60 * 60 * 1000;
  var PERSIST_KEYS = ['color', 'opening', 'width', 'wsub', 'height', 'hsub'];

  /* ---------- Tracking (Google Sheet, optionnel) ----------
     Log chaque interaction avec le formulaire (champ rempli, unité, palier,
     blind complété, ajout au panier) vers un Google Sheet via un webhook Apps
     Script (voir tracking/Code.gs). N'envoie rien tant qu'aucune URL n'est
     configurée (réglage "Tracking — URL du webhook" du bloc). Fire-and-forget :
     ne bloque jamais l'UI, n'affecte jamais l'ajout au panier si le webhook est
     lent ou indisponible (erreurs réseau avalées en silence). */
  function trackId(store, key) {
    try {
      var v = store.getItem(key);
      if (v) return v;
      v = (window.crypto && crypto.randomUUID) ? crypto.randomUUID()
        : (Date.now().toString(36) + Math.random().toString(36).slice(2));
      store.setItem(key, v);
      return v;
    } catch (e) { return ''; }
  }
  var TRACK_VID = trackId(window.localStorage, 'tsv-blinds-vid');
  var TRACK_SID = trackId(window.sessionStorage, 'tsv-blinds-sid');
  var TRACK_DEVICE = /Mobi|Android/i.test(navigator.userAgent) ? 'Mobile' : 'Desktop';

  // Identifiants des choix (ceux de l'ancien widget DPO, gardés pour la persistance).
  var SEL_COLOR = 'select_1001';
  var SEL_OPENING = 'select_1002';

  function getById(id) { return VIRTUAL[id] || document.getElementById(id); }

  // Choix des blinds (copie exacte des selects DPO : textes ET valeurs, pour la persistance).
  function range(a, b) { var r = []; for (var i = a; i <= b; i++) r.push(i); return r; }
  var FRAC_LIST = ['0', '1/16', '1/8', '3/16', '1/4', '5/16', '3/8', '7/16', '1/2', '9/16', '5/8', '11/16', '3/4', '13/16', '7/8', '15/16'];
  function virtualSelect(pairs, placeholder) {
    var sel = document.createElement('select');
    if (placeholder) { var e = document.createElement('option'); e.value = ''; e.textContent = 'enter dimension'; sel.appendChild(e); }
    pairs.forEach(function (p) { var o = document.createElement('option'); o.value = String(p[0]); o.textContent = String(p[1]); sel.appendChild(o); });
    return sel;
  }
  var VIRTUAL = {
    select_1001: virtualSelect([[10001, 'Midnight Black'], [10002, 'Pure White']]),
    select_1002: virtualSelect([[10003, 'Right to left'], [10004, 'Left to right'], [10005, 'Bottom to top']]),
    select_1004: virtualSelect(range(8, 96).map(function (n, i) { return [10008 + i, n]; }), true),
    select_1005: virtualSelect(FRAC_LIST.map(function (t, i) { return [10097 + i, t]; }), true),
    select_1006: virtualSelect(range(8, 96).map(function (n, i) { return [10113 + i, n]; }), true),
    select_1007: virtualSelect(FRAC_LIST.map(function (t, i) { return [10202 + i, t]; }), true),
    cm: [
      virtualSelect(range(20, 244).map(function (n) { return ['w' + n, n]; })),
      virtualSelect(range(0, 9).map(function (n) { return ['wm' + n, n]; })),
      virtualSelect(range(20, 244).map(function (n) { return ['h' + n, n]; })),
      virtualSelect(range(0, 9).map(function (n) { return ['hm' + n, n]; }))
    ]
  };
  function cmSelects() { return VIRTUAL.cm; }

  // Champs communs (couleur/ouverture), affichés quelle que soit l'unité. Rendus
  // en groupes de boutons visuels (swatches / icônes), mais leurs valeurs viennent
  // toujours des vrais <select> DPO (clonées à la construction).
  var COMMON = [
    { key: 'color',   getReal: function () { return getById(SEL_COLOR); },   label: 'Color' },
    { key: 'opening', getReal: function () { return getById(SEL_OPENING); }, label: 'Opening direction' }
  ];
  // Champs dimension selon l'unité. width/height : placeholder vide (force le choix,
  // pilote le gate). sub = sous-unité (16es en pouces, mm en cm) : défaut 0, pas de vide.
  var UNITS = {
    in: { dims: [
      { key: 'width',  getReal: function () { return getById('select_1004'); }, label: 'Width (in)',  placeholder: true },
      { key: 'wsub',   getReal: function () { return getById('select_1005'); }, label: '16ths',       dropEmpty: true },
      { key: 'height', getReal: function () { return getById('select_1006'); }, label: 'Height (in)', placeholder: true },
      { key: 'hsub',   getReal: function () { return getById('select_1007'); }, label: '16ths',       dropEmpty: true }
    ]},
    cm: { dims: [
      { key: 'width',  getReal: function () { return cmSelects()[0]; }, label: 'Width (cm)',  placeholder: true },
      { key: 'wsub',   getReal: function () { return cmSelects()[1]; }, label: 'mm',          dropEmpty: true },
      { key: 'height', getReal: function () { return cmSelects()[2]; }, label: 'Height (cm)', placeholder: true },
      { key: 'hsub',   getReal: function () { return cmSelects()[3]; }, label: 'mm',          dropEmpty: true }
    ]}
  };

  var FRACTIONS = {
    '0': 0, '1/16': 0.0625, '1/8': 0.125, '3/16': 0.1875, '1/4': 0.25,
    '5/16': 0.3125, '3/8': 0.375, '7/16': 0.4375, '1/2': 0.5, '9/16': 0.5625,
    '5/8': 0.625, '11/16': 0.6875, '3/4': 0.75, '13/16': 0.8125, '7/8': 0.875,
    '15/16': 0.9375
  };
  var SHIPPING = [0, 51.61, 53.48, 67.01, 80.42, 93.73, 106.34, 119.49, 132.89,
    146.21, 159.44, 168.67, 180.44, 192.40, 204.22, 215.99];

  // Prix d'une window (formule d'origine de DPO). unit = 'in' | 'cm'. null si incomplet.
  // win.widthMain/heightMain = nombre principal ; win.wsubNum/hsubNum = sous-unité
  // (fraction de pouce en 'in', mm 0-9 en 'cm'). Prix déjà "20% off" (voir volumeExtra).
  function priceFor(win, unit) {
    if (!win || win.widthMain == null || win.heightMain == null) return null;
    var w_m, h_m;
    if (unit === 'cm') {
      w_m = (win.widthMain + (win.wsubNum || 0) / 10) / 100;
      h_m = (win.heightMain + (win.hsubNum || 0) / 10) / 100;
    } else {
      w_m = (win.widthMain + (win.wsubNum || 0)) / 39.37;
      h_m = (win.heightMain + (win.hsubNum || 0)) / 39.37;
    }
    var surface = w_m * h_m;
    var tw = Math.ceil(surface * 2.2);
    if (tw < 1) tw = 1; else if (tw > 15) tw = 15;
    var shipping = SHIPPING[tw];
    var cost_prod = surface * 22;
    var longest = w_m > h_m ? w_m : h_m;
    var oversized = longest >= 1.2 ? 27 : 0;
    var total_cost = cost_prod + shipping + oversized;
    var cost_cad = total_cost * 1.46;
    var mm = 3.53 - 0.0128 * total_cost;
    if (mm > 2.75) mm = 2.75; else if (mm < 2.0) mm = 2.0;
    var pre = cost_cad * mm;
    return Math.ceil((pre + 0.30) / 0.972);
  }
  // Rabais additionnel selon le nombre de blinds, sur le 80% restant (priceFor est
  // déjà à 20% off) : +5% dès 2 blinds (→ 24% off total), +15% dès 3+ (→ 32% off total).
  function volumeExtra(n) { return n >= 3 ? 0.15 : n >= 2 ? 0.05 : 0; }

  function money(n) { return n == null ? '' : '$' + n.toFixed(2); }
  function wait(ms) { return new Promise(function (r) { setTimeout(r, ms); }); }
  function intFromText(t) { var n = parseInt(String(t).trim(), 10); return isNaN(n) ? null : n; }
  function fracFromText(t) { return FRACTIONS[String(t).trim()] || 0; }

  /* ---------- Contrôle du cart drawer (Dawn) ---------- */
  function drawer() { return document.querySelector('cart-drawer'); }
  function openDrawer() {
    var d = drawer();
    try { if (d && typeof d.open === 'function') { d.open(); return; } } catch (e) {}
    if (d && d.classList) d.classList.add('active');
  }

  /* ---------- Couleurs & icônes de direction (visuel) ----------
     DPO ne fournit que des libellés texte (ex: "Midnight Black", "Pure White",
     "Right to Left") ; on les mappe ici sur une couleur / une icône. Si une
     nouvelle couleur ou direction est ajoutée côté DPO, étendre ces maps. */
  function colorHexFor(label) {
    var l = (label || '').toLowerCase();
    if (l.indexOf('white') !== -1) return '#ffffff';
    if (l.indexOf('black') !== -1) return '#141414';
    return '#cccccc'; // fallback neutre si une couleur inconnue apparaît côté DPO
  }
  // Icônes = rectangle (le blind) avec une partie sombre (fermée) et une partie
  // ouverte du côté indiqué par la direction. Le carré sombre marque le côté FERMÉ
  // (où le tissu s'accumule) ; le côté ouvert est celui d'où l'ouverture part.
  var OPENING_ICONS = {
    ltr: { box: { w: 26, h: 21, vb: '-1 -1 16 13' },
      svg: '<rect x="7" y="1" width="6" height="9" rx="1" fill="currentColor" opacity=".82"/><rect x="0" y="0" width="14" height="11" rx="2" fill="none" stroke="currentColor" stroke-width="1.5"/>' },
    rtl: { box: { w: 26, h: 21, vb: '-1 -1 16 13' },
      svg: '<rect x="1" y="1" width="6" height="9" rx="1" fill="currentColor" opacity=".82"/><rect x="0" y="0" width="14" height="11" rx="2" fill="none" stroke="currentColor" stroke-width="1.5"/>' },
    btt: { box: { w: 21, h: 26, vb: '-1 -1 13 16' },
      svg: '<rect x="1" y="1" width="9" height="6" rx="1" fill="currentColor" opacity=".82"/><rect x="0" y="0" width="11" height="14" rx="2" fill="none" stroke="currentColor" stroke-width="1.5"/>' }
  };
  function openingIconFor(label) {
    // Libellés réels DPO : "R→L", "L→R", "Bottom→top" (notation courte, pas les
    // mots au long). On lit juste le préfixe : "bottom"/"top" → vertical, "R" en
    // tête → droite-à-gauche, sinon (dont "L") → gauche-à-droite par défaut.
    var l = (label || '').trim().toLowerCase();
    if (l.indexOf('bottom') !== -1 || l.indexOf('top') !== -1) return OPENING_ICONS.btt;
    if (l.charAt(0) === 'r') return OPENING_ICONS.rtl;
    return OPENING_ICONS.ltr;
  }

  /* =========================================================================
     UI MULTI
     ========================================================================= */
  function initMulti(card) {
    if (card.__multiInit) return;
    card.__multiInit = true;

    // Table prix -> variante du produit caché (une variante par prix entier).
    var prixVariantes = {};
    try { prixVariantes = (JSON.parse(card.getAttribute('data-prix-variantes') || '{}') || {}).v || {}; } catch (e) {}

    var tiersWrap = card.querySelector('[data-blinds-tiers]');
    var windowsWrap = card.querySelector('[data-blinds-windows]');
    var totalEl = card.querySelector('[data-blinds-total]');
    var regularEl = card.querySelector('[data-blinds-regular]');
    var savingsEl = card.querySelector('[data-blinds-savings]');
    var addMoreBtn = card.querySelector('[data-blinds-addmore]');
    var atc = card.querySelector('[data-blinds-atc]');
    var errorEl = card.querySelector('[data-blinds-error]');
    if (!windowsWrap || !atc) return;

    var windowTitleTpl = card.getAttribute('data-window-title-template') || 'Blinds [n]';
    var errorIncompleteTpl = card.getAttribute('data-error-incomplete-text') || 'Complete [blinds] to add to cart.';
    var errorSuggestionTpl = card.getAttribute('data-error-suggestion-text') || '';

    // ---- Tracking : URL du webhook (vide = tracking désactivé) ----
    var trackingUrl = card.getAttribute('data-tracking-url') || '';
    function windowIndex(winEl) {
      if (!winEl) return null;
      var idx = Array.prototype.indexOf.call(windowsWrap.querySelectorAll('.win'), winEl);
      return idx === -1 ? null : idx + 1;
    }
    function track(type, extra) {
      if (!trackingUrl) return;
      var payload = {
        vid: TRACK_VID, sid: TRACK_SID, type: type,
        unit: state.unit, qty: state.qty,
        url: location.href, device: TRACK_DEVICE
      };
      if (extra) for (var k in extra) payload[k] = extra[k];
      try {
        fetch(trackingUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'text/plain;charset=utf-8' },
          body: JSON.stringify(payload)
        }).catch(function () {});
      } catch (e) {}
    }

    // ---- Image swap couleur (léger) : la couleur du Blind 1 seulement pilote
    // certaines images de la galerie produit Dawn. Blind 2/3+ n'y touchent jamais.
    // Chaque paire noir/blanc est repérée par texte alt EXACT (insensible à la
    // casse) sur les médias du produit (Shopify admin, pas de code à toucher pour
    // en ajouter) : "hero-black"/"hero-white" (image principale), "window-
    // black"/"window-white" (photo blind dans une fenêtre). Une paire dont l'un
    // des deux alt est absent est ignorée en silence (pas d'erreur).
    // Implémenté en toggle de visibilité (display:none), pas en navigation de
    // slider : chaque paire reste à sa position dans la galerie, seule l'image
    // affichée change — évite les sauts si le client est en train de scroller la
    // galerie. Dawn rend chaque média deux fois (le slide principal, data-media-id
    // sur le <li>, ET sa vignette dans le thumbnail-slider, data-target sur le
    // <li> — pas le même attribut) : on cache les deux ensemble, sinon la vignette
    // de la couleur non choisie reste visible dans le carrousel.
    // La paire "hero" a `activates: true` : en plus du toggle de visibilité, elle
    // pilote le slide actif du viewer via setActiveMedia (méthode standard Dawn
    // sur <media-gallery>) — sinon le grand format reste figé sur l'ancienne
    // couleur même une fois cachée. Les autres paires (window) ne forcent pas la
    // navigation : elles changent juste de contenu là où le client scrolle.
    var HERO_PAIRS = [
      { black: 'hero-black', white: 'hero-white', activates: true },
      { black: 'window-black', white: 'window-white' }
    ];
    var heroGallery = document.querySelector('media-gallery');
    var heroPairsEls = null; // résolu au premier recompute
    var lastHeroWhite = false; // état au premier rendu = noir (défaut colorField)
    function scanHeroGallery() {
      heroPairsEls = [];
      if (!heroGallery) return;
      var slides = heroGallery.querySelectorAll('[data-media-id]');
      HERO_PAIRS.forEach(function (pair) {
        var blackSlide = null, whiteSlide = null;
        Array.prototype.forEach.call(slides, function (s) {
          var img = s.querySelector('img');
          var alt = img ? (img.getAttribute('alt') || '').trim().toLowerCase() : '';
          if (alt === pair.black) blackSlide = s;
          if (alt === pair.white) whiteSlide = s;
        });
        if (!blackSlide || !whiteSlide) return;
        var blackEls = [blackSlide], whiteEls = [whiteSlide];
        var blackThumb = heroGallery.querySelector('[data-target="' + blackSlide.getAttribute('data-media-id') + '"]');
        var whiteThumb = heroGallery.querySelector('[data-target="' + whiteSlide.getAttribute('data-media-id') + '"]');
        if (blackThumb) blackEls.push(blackThumb);
        if (whiteThumb) whiteEls.push(whiteThumb);
        whiteEls.forEach(function (e) { e.style.display = 'none'; }); // état initial = noir
        heroPairsEls.push({ black: blackEls, white: whiteEls, activates: pair.activates });
      });
    }
    function updateHeroImage(colorText) {
      if (!heroPairsEls) scanHeroGallery();
      if (!heroPairsEls.length) return;
      var isWhite = (colorText || '').toLowerCase().indexOf('white') !== -1;
      if (isWhite === lastHeroWhite) return;
      lastHeroWhite = isWhite;
      heroPairsEls.forEach(function (p) {
        var show = isWhite ? p.white : p.black;
        var hide = isWhite ? p.black : p.white;
        show.forEach(function (e) { e.style.display = ''; });
        hide.forEach(function (e) { e.style.display = 'none'; });
        if (p.activates && heroGallery && typeof heroGallery.setActiveMedia === 'function') {
          heroGallery.setActiveMedia(show[0].getAttribute('data-media-id'), true);
        }
      });
    }

    // Ligne warranty à deux états (voir markup) : sous le seuil, la ligne "base"
    // est visible et la ligne "perk" affiche le cadenas ; au seuil, l'inverse.
    var warrantyBase = card.querySelector('[data-warranty-base]');
    var warrantyPerk = card.querySelector('[data-warranty-perk]');
    var warrantyText = card.querySelector('[data-warranty-text]');
    var warrantyBadge = card.querySelector('[data-warranty-badge]');
    var warrantyStrike = card.querySelector('[data-warranty-strike]');
    var warrantyMin = warrantyPerk ? (parseInt(warrantyPerk.getAttribute('data-warranty-min'), 10) || 2) : 2;
    var warrantyLockedText = warrantyPerk ? (warrantyPerk.getAttribute('data-warranty-locked-text') || '') : '';
    var warrantyUnlockedText = warrantyPerk ? (warrantyPerk.getAttribute('data-warranty-unlocked-text') || '') : '';
    // Prix barré = ce montant × le nombre de blinds (ex. 40$/blind → 80$ à 2, 120$ à 3).
    var warrantyStrikePer = warrantyPerk ? (parseFloat(warrantyPerk.getAttribute('data-warranty-strike-per')) || 0) : 0;
    function reflectWarranty(qty) {
      if (!warrantyPerk) return;
      var unlocked = qty >= warrantyMin;
      if (warrantyBase) warrantyBase.hidden = unlocked;
      warrantyPerk.classList.toggle('is-locked', !unlocked);
      if (warrantyText) warrantyText.textContent = unlocked ? warrantyUnlockedText : warrantyLockedText.replace('[qty]', warrantyMin);
      if (warrantyBadge) warrantyBadge.hidden = !unlocked;
      if (warrantyStrike) {
        warrantyStrike.hidden = !unlocked;
        if (unlocked) warrantyStrike.textContent = money(warrantyStrikePer * qty);
      }
    }

    var tierBtns = tiersWrap ? Array.prototype.slice.call(tiersWrap.querySelectorAll('[data-tier]')) : [];

    var state = { qty: 1, tierMin: 1, open: false, unit: 'in', windows: [] };
    var ready = false; // true une fois l'init/restauration finie (autorise la sauvegarde)

    /* ---- Generic element helper ---- */
    function el(tag, cls) { var e = document.createElement(tag); if (cls) e.className = cls; return e; }
    function opt(v, t, sel) { var o = document.createElement('option'); o.value = v; o.textContent = t; if (sel) o.selected = true; return o; }

    // Construit un <select> pour un champ de dimension, en clonant les options du
    // vrai select DPO. placeholder:true garantit une option vide en tête (ajoutée si
    // le vrai select n'en a pas, ex: les champs cm) pour forcer le choix. dropEmpty:true
    // retire l'option vide (sous-unités : défaut 0).
    function buildSelect(field) {
      var real = field.getReal();
      var sel = document.createElement('select');
      sel.setAttribute('data-field', field.key);
      var hasEmpty = false;
      if (real) Array.prototype.forEach.call(real.options, function (o) {
        if (field.dropEmpty && o.value === '') return;
        if (o.value === '') hasEmpty = true;
        var text = (o.textContent || '').trim() || 'enter dimension';
        sel.appendChild(opt(o.value, text));
      });
      if (field.placeholder && !hasEmpty) {
        sel.insertBefore(opt('', 'enter dimension'), sel.firstChild);
        sel.setAttribute('data-empty', '1');
      }
      sel.selectedIndex = 0;
      sel.addEventListener('change', function () {
        if (sel.value === '') sel.setAttribute('data-empty', '1'); else sel.removeAttribute('data-empty');
        recompute();
        if (sel.value !== '') {
          var chosen = sel.options[sel.selectedIndex];
          track('field_change', { field: field.key, value: sel.value, text: chosen ? chosen.textContent.trim() : '', win: windowIndex(sel.closest('.win')) });
        }
      });
      return sel;
    }
    function fieldSelect(label, sel) {
      var wrap = el('label', 'bo-field');
      var lab = el('span', 'bo-field__label'); lab.textContent = label;
      wrap.appendChild(lab); wrap.appendChild(sel);
      return wrap;
    }

    // Trie une liste d'options en mettant en tête celles qui matchent `priority`
    // (tri stable : l'ordre d'origine est conservé au sein de chaque groupe).
    // Sert à faire passer un choix précis en premier — indépendant de l'ordre
    // réel des options côté DPO, qu'on ne contrôle pas.
    function sortByPriority(options, priority) {
      var arr = Array.prototype.map.call(options, function (o, i) { return { o: o, i: i }; });
      arr.sort(function (a, b) {
        var pa = priority(a.o) ? 0 : 1, pb = priority(b.o) ? 0 : 1;
        return pa !== pb ? pa - pb : a.i - b.i;
      });
      return arr.map(function (x) { return x.o; });
    }

    // ---- Color swatches (valeurs de VIRTUAL.select_1001) ----
    // Noir en premier + sélectionné par défaut.
    function colorField() {
      var real = COMMON[0].getReal();
      var wrap = el('div', 'bo-field bo-field--full');
      var lab = el('span', 'bo-field__label'); lab.textContent = 'Color'; wrap.appendChild(lab);
      var row = el('div', 'bo-swatches'); row.setAttribute('data-field', 'color');
      var name = el('span', 'bo-swatches__name');
      if (real) {
        var opts = sortByPriority(real.options, function (o) { return (o.textContent || '').toLowerCase().indexOf('black') !== -1; });
        opts.forEach(function (o, idx) {
          if (o.value === '') return;
          var label = (o.textContent || '').trim();
          var b = el('button', 'bo-swatch'); b.type = 'button'; b.setAttribute('data-value', o.value);
          b.style.background = colorHexFor(label); b.title = label;
          b.appendChild(el('span', 'bo-swatch__tick'));
          b.addEventListener('click', function () {
            Array.prototype.forEach.call(row.querySelectorAll('.bo-swatch'), function (s) { s.classList.remove('is-selected'); });
            b.classList.add('is-selected'); name.textContent = label; recompute();
            track('field_change', { field: 'color', value: o.value, text: label, win: windowIndex(b.closest('.win')) });
          });
          if (idx === 0) { b.classList.add('is-selected'); name.textContent = label; }
          row.appendChild(b);
        });
      }
      var line = el('div'); line.style.display = 'flex'; line.style.alignItems = 'center'; line.style.gap = '14px';
      line.appendChild(row); line.appendChild(name);
      wrap.appendChild(line);
      return wrap;
    }

    // ---- Opening direction, visuelle (valeurs de VIRTUAL.select_1002) ----
    // Bottom to top en premier + sélectionné par défaut.
    function openingField() {
      var real = COMMON[1].getReal();
      var wrap = el('div', 'bo-field bo-field--full');
      var lab = el('span', 'bo-field__label'); lab.textContent = 'Opening direction'; wrap.appendChild(lab);
      var grid = el('div', 'openings'); grid.setAttribute('data-field', 'opening');
      if (real) {
        var opts = sortByPriority(real.options, function (o) { return (o.textContent || '').toLowerCase().indexOf('bottom') !== -1; });
        opts.forEach(function (o, idx) {
          if (o.value === '') return;
          var label = (o.textContent || '').trim();
          var icon = openingIconFor(label);
          var b = el('button', 'opening'); b.type = 'button'; b.setAttribute('data-value', o.value);
          var rectSvg = '<svg class="opening__rect" viewBox="' + icon.box.vb + '" width="' + icon.box.w + '" height="' + icon.box.h + '" aria-hidden="true">' + icon.svg + '</svg>';
          b.innerHTML = '<span class="opening__icons">' + rectSvg + '</span><span>' + label + '</span>';
          b.addEventListener('click', function () {
            Array.prototype.forEach.call(grid.querySelectorAll('.opening'), function (s) { s.classList.remove('is-selected'); });
            b.classList.add('is-selected'); recompute();
            track('field_change', { field: 'opening', value: o.value, text: label, win: windowIndex(b.closest('.win')) });
          });
          if (idx === 0) b.classList.add('is-selected');
          grid.appendChild(b);
        });
      }
      wrap.appendChild(grid);
      return wrap;
    }

    // ---- Lecture/écriture générique d'un champ (select classique OU groupe de
    // boutons — color/opening). Utilisé par recompute (lecture) et par la
    // persistance (lecture + restauration). ----
    function getFieldValue(container, key) {
      var c = container.querySelector('[data-field="' + key + '"]');
      if (!c) return { val: '', text: '' };
      if (c.tagName === 'SELECT') {
        var o = c.options[c.selectedIndex];
        return { val: c.value, text: o ? o.textContent.trim() : '' };
      }
      var b = c.querySelector('.is-selected');
      return { val: b ? b.getAttribute('data-value') : '', text: b ? (b.title || '') : '' };
    }
    function setFieldValue(container, key, val) {
      if (val == null) return;
      var c = container.querySelector('[data-field="' + key + '"]');
      if (!c) return;
      if (c.tagName === 'SELECT') {
        for (var i = 0; i < c.options.length; i++) {
          if (c.options[i].value === val) { c.selectedIndex = i; c.value = val; if (val === '') c.setAttribute('data-empty', '1'); else c.removeAttribute('data-empty'); return; }
        }
        return;
      }
      var btns = c.querySelectorAll('[data-value]');
      var picked = null;
      Array.prototype.forEach.call(btns, function (b) {
        var on = b.getAttribute('data-value') === val;
        b.classList.toggle('is-selected', on);
        if (on) picked = b;
      });
      if (key === 'color') {
        var name = c.parentNode.querySelector('.bo-swatches__name');
        if (name && picked) name.textContent = picked.title;
      }
    }

    // Lit une window (champs communs + dimensions de l'unité active) et calcule son prix.
    function readWindow(el, unit) {
      var win = { el: el };
      var c = getFieldValue(el, 'color'); win.colorVal = c.val; win.colorText = c.text;
      var o = getFieldValue(el, 'opening'); win.openingVal = o.val; win.openingText = o.text;
      UNITS[unit].dims.forEach(function (f) {
        var sel = el.querySelector('[data-field="' + f.key + '"]');
        var opt = sel && sel.options[sel.selectedIndex];
        win[f.key + 'Val'] = sel ? sel.value : '';
        win[f.key + 'Text'] = opt ? opt.textContent.trim() : '';
      });
      win.widthMain = win.widthVal === '' ? null : intFromText(win.widthText);
      win.heightMain = win.heightVal === '' ? null : intFromText(win.heightText);
      if (unit === 'cm') {
        win.wsubNum = intFromText(win.wsubText) || 0; // mm 0-9
        win.hsubNum = intFromText(win.hsubText) || 0;
      } else {
        win.wsubNum = fracFromText(win.wsubText);     // fraction de pouce
        win.hsubNum = fracFromText(win.hsubText);
      }
      // Couleur (noir) et ouverture (bottom to top) ont une valeur par défaut au
      // premier rendu (voir colorField/openingField) ; ce check reste utile si un
      // jour une window démarre sans défaut (ex: select DPO vide).
      win.complete = win.colorVal !== '' && win.openingVal !== '' && win.widthMain != null && win.heightMain != null;
      win.price = priceFor(win, unit);
      return win;
    }

    function buildWindowEl(index) {
      // Chaque window = accordéon mince. Header "Blinds N" + prix (visible même
      // replié, donc statut d'un coup d'œil). Tous fermés par défaut (l'utilisateur
      // ouvre ceux qu'il veut remplir) — sauf celle qu'on vient d'ajouter, voir addWindow().
      var d = document.createElement('details');
      d.className = 'win';

      var head = document.createElement('summary');
      head.className = 'win__head';
      head.innerHTML =
        '<span class="win__id"><span class="win__dot" aria-hidden="true"></span>' + windowTitleTpl.replace('[n]', index + 1) + '</span>'
        + '<span class="win__meta">'
        + '<span class="win__price-cluster"><span class="win__price-now" data-win-now></span><span class="win__pct" data-win-pct hidden></span></span>'
        + '<button type="button" class="win__rm" aria-label="Remove this blind">&times;</button>'
        + '<span class="win__chev" aria-hidden="true"></span></span>';
      d.appendChild(head);
      head.querySelector('.win__rm').addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation(); removeWindowEl(d);
      });

      var body = document.createElement('div');
      body.className = 'win__body';
      body.appendChild(colorField());
      body.appendChild(openingField());
      var dims = document.createElement('div');
      dims.className = 'dims';
      dims.setAttribute('data-dims', '');
      body.appendChild(dims);
      d.appendChild(body);

      renderDims(d);
      return d;
    }

    // (Re)construit les champs de dimension d'une window selon l'unité courante.
    function renderDims(d) {
      var dims = d.querySelector('[data-dims]');
      if (!dims) return;
      dims.innerHTML = '';
      UNITS[state.unit].dims.forEach(function (f) { dims.appendChild(fieldSelect(f.label, buildSelect(f))); });
    }

    function currentCount() { return windowsWrap.querySelectorAll('.win').length; }

    // Ajuste le nombre de windows à n en conservant les valeurs déjà saisies
    // (on n'ajoute/retire qu'en fin de liste).
    function setCount(n) {
      var existing = currentCount();
      if (n > existing) {
        for (var i = existing; i < n; i++) windowsWrap.appendChild(buildWindowEl(i));
      } else if (n < existing) {
        var els = windowsWrap.querySelectorAll('.win');
        for (var j = existing - 1; j >= n; j--) els[j].remove();
      }
      renumber();
      recompute();
    }

    // Renumérote les headers, met à jour quelles windows sont retirables (palier
    // ouvert, au-delà du minimum) et l'affichage du bouton "add more".
    function renumber() {
      var els = windowsWrap.querySelectorAll('.win');
      Array.prototype.forEach.call(els, function (d, i) {
        var idEl = d.querySelector('.win__id');
        if (idEl) idEl.childNodes[1].nodeValue = windowTitleTpl.replace('[n]', i + 1);
        d.classList.toggle('is-removable', state.open && i >= state.tierMin);
      });
      state.qty = els.length;
      if (addMoreBtn) addMoreBtn.hidden = !state.open;
    }

    function removeWindowEl(el) {
      if (currentCount() <= state.tierMin) return; // ne pas descendre sous le minimum du palier
      el.remove();
      renumber();
      recompute();
    }

    function addWindow() {
      setCount(currentCount() + 1);
      var els = windowsWrap.querySelectorAll('.win');
      var last = els[els.length - 1];
      if (last) last.open = true; // ouvre la nouvelle
    }

    // Recalcule prix par window (+ badge %off) et total (+ prix régulier barré +
    // badge d'économie). Retourne true si toutes les windows sont complètes.
    function recompute() {
      hideError(); // tout changement de champ efface un message d'erreur affiché plus tôt
      var els = windowsWrap.querySelectorAll('.win');
      state.windows = [];
      var complete = els.length > 0;
      var volMult = 1 - volumeExtra(els.length);
      var total = 0, regularTotal = 0;
      var pctOff = Math.round((1 - 0.8 * volMult) * 100); // 20% off (+4pt à 2 blinds, +12pt à 3+)

      Array.prototype.forEach.call(els, function (d) {
        var win = readWindow(d, state.unit);
        state.windows.push(win);
        var nowEl = d.querySelector('[data-win-now]');
        var pctEl = d.querySelector('[data-win-pct]');
        d.classList.toggle('is-done', win.complete);
        if (!win.complete || win.price == null) {
          complete = false;
          d.__trackedComplete = false;
          if (nowEl) nowEl.textContent = '';
          if (pctEl) pctEl.hidden = true;
        } else {
          var regular = Math.round(win.price / 0.8); // prix régulier (garde en interne pour le total barré en bas)
          var now = Math.round(win.price * volMult);
          total += now; regularTotal += regular;
          if (nowEl) nowEl.textContent = money(now);
          if (pctEl) { pctEl.textContent = '-' + pctOff + '%'; pctEl.hidden = false; }
          if (!d.__trackedComplete) {
            d.__trackedComplete = true;
            track('window_complete', { win: windowIndex(d) });
          }
        }
      });

      if (state.windows[0]) updateHeroImage(state.windows[0].colorText);

      card.classList.toggle('is-complete', complete);
      if (complete) {
        var savePct = Math.round((1 - total / regularTotal) * 100);
        if (totalEl) totalEl.textContent = money(total);
        if (regularEl) regularEl.textContent = money(regularTotal);
        if (savingsEl) savingsEl.textContent = savePct + '% off';
      }
      reflectWarranty(els.length);
      if (ready) saveState();
      return complete;
    }

    // Propriétés de ligne : mêmes noms que DPO (panier, checkout, commandes inchangés).
    function lineProps(win) {
      // Textes lus dans les choix (les boutons d'ouverture n'ont pas de title, contrairement aux pastilles de couleur)
      function texte(id, val) { var o = Array.prototype.find.call(VIRTUAL[id].options, function (x) { return x.value === val; }); return o ? o.textContent : ''; }
      var p = { 'Color': texte('select_1001', win.colorVal), 'Opening direction': texte('select_1002', win.openingVal) };
      if (state.unit === 'cm') {
        p['Unit'] = 'Centimeters';
        p['Width (cm)'] = String(win.widthMain); p['Millimeters'] = String(win.wsubNum || 0);
        p['Height (cm)'] = String(win.heightMain); p['Millimeters #2'] = String(win.hsubNum || 0);
      } else {
        p['Unit'] = 'Inches';
        p['Width (in)'] = String(win.widthMain); p['Sixteenths'] = win.wsubText || '0';
        p['Height (in)'] = String(win.heightMain); p['Sixteenths #2'] = win.hsubText || '0';
      }
      return p;
    }

    async function addAll() {
      if (!recompute()) { blockAdd(); return; }
      var wins = state.windows.slice(0, state.qty);
      var items = [];
      for (var i = 0; i < wins.length; i++) {
        var id = prixVariantes[String(wins[i].price)];
        if (!id) { showError('This size can’t be ordered online. Please contact us.'); track('add_to_cart_error', { text: 'prix sans variante ' + wins[i].price }); return; }
        items.push({ id: id, quantity: 1, properties: lineProps(wins[i]) });
      }
      atc.disabled = true;
      var original = atc.textContent;
      atc.textContent = 'Adding…';
      card.classList.add('blinds-offer--adding');
      var d = drawer();
      var addedOk = false;
      try {
        var res = await fetch(window.Shopify && Shopify.routes ? Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: items, sections: d && d.getSectionsToRender ? d.getSectionsToRender().map(function (x) { return x.id; }) : undefined, sections_url: window.location.pathname })
        });
        var data = await res.json();
        if (!res.ok || data.status) throw new Error(data.description || data.message || ('HTTP ' + res.status));
        addedOk = true;
        // Comme le formulaire produit de Dawn : panier redessiné, puis événement (synchro de la garantie, bonus).
        if (d && typeof d.renderContents === 'function' && data.sections) d.renderContents(data);
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') publish(PUB_SUB_EVENTS.cartUpdate, { source: 'blinds-offer', cartData: data });
      } catch (e) {
        console.error('[blinds-offer] add error', e);
        showError('Something went wrong. Please try again.');
      } finally {
        atc.disabled = false;
        atc.textContent = original;
        card.classList.remove('blinds-offer--adding');
        if (addedOk) {
          if (d && typeof d.open === 'function' && !(data && data.sections)) openDrawer();
          track('add_to_cart_success', { qty: wins.length });
          resetConfig(); // config commise au panier : on vide et repart à neuf
        }
      }
    }

    // Ne touche NI au scroll NI au DOM au-dessus du bouton : le visiteur vient de
    // cliquer ATC, il est déjà sur le bouton/message d'erreur. Ancienne version
    // dépliait aussi la window incomplète (`el.open = true`) — retiré (2026-08-21) :
    // une <details> qui passe de repliée à dépliée ajoute d'un coup sa pleine
    // hauteur dans la carte, ça pousse tout le contenu et donne l'impression que la
    // page saute, même sans aucun scroll JS. Le message d'erreur nomme déjà le bon
    // blind ; le visiteur ouvre lui-même l'accordéon, ce qui est un mouvement de
    // page qu'il déclenche et attend, pas un qui lui est imposé.
    function nudge() {
      card.classList.add('blinds-offer--nudge');
      setTimeout(function () { card.classList.remove('blinds-offer--nudge'); }, 550);
    }

    // Windows sans .is-done (posée par recompute). Vide si tout est complet.
    function incompleteWindowEls() {
      return Array.prototype.filter.call(windowsWrap.querySelectorAll('.win'), function (el) {
        return !el.classList.contains('is-done');
      });
    }

    // "blind 2" / "blinds 2 and 3" / "blinds 2, 3 and 4".
    function formatBlindList(indices) {
      var noun = indices.length === 1 ? 'blind' : 'blinds';
      var nums = indices.length === 1 ? String(indices[0])
        : indices.length === 2 ? indices[0] + ' and ' + indices[1]
        : indices.slice(0, -1).join(', ') + ' and ' + indices[indices.length - 1];
      return noun + ' ' + nums;
    }

    // Libellé du palier le plus haut, sous le palier actif, DÉJÀ entièrement
    // couvert par les windows complètes (ex. "1 blind" si 1 seule window est
    // complète, peu importe le palier actif) — jamais un palier qui bloquerait
    // encore. null si aucun palier sous l'actif n'est couvert (rien de complété).
    function lowerTierSuggestion() {
      var activeIdx = -1;
      tierBtns.forEach(function (b, i) { if (b.classList.contains('is-active')) activeIdx = i; });
      if (activeIdx <= 0) return null;
      var done = windowsWrap.querySelectorAll('.win.is-done').length;
      var best = null;
      for (var i = activeIdx - 1; i >= 0; i--) {
        var min = parseInt(tierBtns[i].getAttribute('data-tier'), 10) || 1;
        if (done >= min) { best = tierBtns[i]; break; }
      }
      if (!best) return null;
      var count = ((best.querySelector('.tier__count') || {}).textContent || '').trim();
      var unit = ((best.querySelector('.tier__unit') || {}).textContent || '').trim().toLowerCase();
      if (count === '1') unit = unit.replace(/s$/, '');
      return (count + ' ' + unit).trim();
    }

    // Message d'erreur affiché quand un clic ATC échoue sur des windows incomplètes.
    function buildErrorMessage(incompleteEls) {
      var indices = incompleteEls.map(function (el) { return windowIndex(el); });
      var msg = errorIncompleteTpl.replace('[blinds]', formatBlindList(indices));
      var tier = lowerTierSuggestion();
      if (tier && errorSuggestionTpl) msg += ' ' + errorSuggestionTpl.replace('[tier]', tier);
      return msg;
    }

    function showError(text) {
      if (!errorEl) return;
      errorEl.textContent = text;
      errorEl.hidden = false;
    }
    function hideError() {
      if (errorEl && !errorEl.hidden) errorEl.hidden = true;
    }

    // Échec du gate ATC : nudge + message précis nommant les windows incomplètes.
    function blockAdd() {
      var incomplete = incompleteWindowEls();
      nudge();
      if (incomplete.length) showError(buildErrorMessage(incomplete));
      track('add_to_cart_blocked');
    }

    if (addMoreBtn) addMoreBtn.addEventListener('click', addWindow);

    // Sélecteur d'unité (pouces / cm). Global : toutes les windows utilisent la même
    // unité. Changer l'unité convertit la config en cours (au 1/16" ou au mm le plus
    // proche) au lieu de la perdre. Color/opening ne dépendent pas de l'unité, donc
    // ne sont jamais reconstruits ici.
    var FRAC_TEXT = ['0', '1/16', '1/8', '3/16', '1/4', '5/16', '3/8', '7/16',
      '1/2', '9/16', '5/8', '11/16', '3/4', '13/16', '7/8', '15/16'];

    // Taille physique en pouces à partir des valeurs d'une unité (sub = fraction de
    // pouce en 'in', mm 0-9 en 'cm').
    function toInches(main, sub, unit) {
      if (unit === 'cm') return (main + (sub || 0) / 10) / 2.54;
      return main + (sub || 0);
    }
    function setSelectByText(sel, text) {
      if (!sel) return;
      for (var i = 0; i < sel.options.length; i++) {
        if ((sel.options[i].textContent || '').trim() === text) {
          sel.selectedIndex = i;
          sel.value = sel.options[i].value;
          if (sel.value === '') sel.setAttribute('data-empty', '1'); else sel.removeAttribute('data-empty');
          return;
        }
      }
    }
    // Pose une dimension convertie (totalIn = taille en pouces) sur les champs de
    // l'unité cible, en snappant sur les options disponibles.
    function applyConvertedDim(el, mainKey, subKey, totalIn, unit) {
      var whole, subText;
      if (unit === 'cm') {
        var tmm = Math.round(totalIn * 2.54 * 10);
        whole = Math.floor(tmm / 10);
        var mm = tmm % 10;
        if (whole < 20) { whole = 20; mm = 0; }
        else if (whole > 244) { whole = 244; mm = 0; }
        subText = String(mm);
      } else {
        var t16 = Math.round(totalIn * 16);
        whole = Math.floor(t16 / 16);
        var frac = t16 % 16;
        if (whole < 8) { whole = 8; frac = 0; }
        else if (whole > 96) { whole = 96; frac = 0; }
        subText = FRAC_TEXT[frac];
      }
      setSelectByText(el.querySelector('[data-field="' + mainKey + '"]'), String(whole));
      setSelectByText(el.querySelector('[data-field="' + subKey + '"]'), subText);
    }

    var unitsWrap = card.querySelector('[data-blinds-units]');
    var unitBtns = unitsWrap ? Array.prototype.slice.call(unitsWrap.querySelectorAll('[data-unit]')) : [];
    function setUnit(u) {
      if (!UNITS[u] || u === state.unit) return;
      var from = state.unit;
      // Capture les dimensions actuelles (dans l'ancienne unité) AVANT le rebuild.
      var captured = [];
      Array.prototype.forEach.call(windowsWrap.querySelectorAll('.win'), function (el) {
        var w = readWindow(el, from);
        captured.push({
          el: el,
          wIn: w.widthMain == null ? null : toInches(w.widthMain, w.wsubNum, from),
          hIn: w.heightMain == null ? null : toInches(w.heightMain, w.hsubNum, from)
        });
      });
      state.unit = u;
      unitBtns.forEach(function (b) { b.classList.toggle('is-active', b.getAttribute('data-unit') === u); });
      // Rebuild dans la nouvelle unité + réinjecte les dimensions converties.
      captured.forEach(function (c) {
        renderDims(c.el);
        if (c.wIn != null) applyConvertedDim(c.el, 'width', 'wsub', c.wIn, u);
        if (c.hIn != null) applyConvertedDim(c.el, 'height', 'hsub', c.hIn, u);
      });
      recompute();
      track('unit_change', { text: u === 'cm' ? 'Centimètres' : 'Pouces' });
    }
    unitBtns.forEach(function (btn) {
      btn.addEventListener('click', function () { setUnit(btn.getAttribute('data-unit')); });
    });

    // Sélecteur de paliers. data-tier = minimum ; data-tier-open="true" = palier ouvert
    // (3+), qui affiche le bouton add-more et permet de retirer au-delà du minimum.
    tierBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        state.tierMin = parseInt(btn.getAttribute('data-tier'), 10) || 1;
        state.open = btn.getAttribute('data-tier-open') === 'true';
        tierBtns.forEach(function (b) { b.classList.toggle('is-active', b === btn); });
        setCount(state.tierMin);
        track('tier_change', { field: 'tier', value: state.tierMin, text: btn.textContent.replace(/\s+/g, ' ').trim() });
      });
    });

    // Bouton d'ajout (gate + séquence).
    atc.addEventListener('click', function () {
      if (!recompute()) { blockAdd(); return; }
      track('add_to_cart_attempt');
      addAll();
    });

    // Défauts du bloc (depuis les boutons is-active du Liquid, avant restauration).
    var defaultUnit = (unitsWrap && unitsWrap.querySelector('[data-unit].is-active'))
      ? unitsWrap.querySelector('[data-unit].is-active').getAttribute('data-unit') : 'in';
    var _defTier = tiersWrap && tiersWrap.querySelector('[data-tier].is-active');
    var defaultTier = _defTier ? (parseInt(_defTier.getAttribute('data-tier'), 10) || 1) : 1;
    var defaultOpen = _defTier ? _defTier.getAttribute('data-tier-open') === 'true' : false;

    // ---- Persistance (localStorage) ----
    function saveState() {
      try {
        var data = { v: 1, ts: Date.now(), unit: state.unit, qty: state.qty, tierMin: state.tierMin, open: state.open, windows: [] };
        Array.prototype.forEach.call(windowsWrap.querySelectorAll('.win'), function (el) {
          var w = {};
          PERSIST_KEYS.forEach(function (k) { w[k] = getFieldValue(el, k).val; });
          data.windows.push(w);
        });
        localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
      } catch (e) {}
    }
    function loadSaved() {
      try {
        var raw = localStorage.getItem(STORAGE_KEY);
        if (!raw) return null;
        var d = JSON.parse(raw);
        if (!d || d.v !== 1) return null;
        if (d.ts && (Date.now() - d.ts) > STORAGE_TTL) { localStorage.removeItem(STORAGE_KEY); return null; }
        return d;
      } catch (e) { return null; }
    }
    function restoreWindow(el, sw) {
      PERSIST_KEYS.forEach(function (k) {
        if (sw[k] != null && sw[k] !== '') setFieldValue(el, k, sw[k]);
      });
    }
    // Vide la config sauvegardée et remet le formulaire à neuf (appelé après un ajout
    // au panier réussi : la config est commise au panier, on repart propre).
    function resetConfig() {
      try { localStorage.removeItem(STORAGE_KEY); } catch (e) {}
      state.unit = defaultUnit; state.tierMin = defaultTier; state.open = defaultOpen;
      unitBtns.forEach(function (b) { b.classList.toggle('is-active', b.getAttribute('data-unit') === state.unit); });
      tierBtns.forEach(function (b) { b.classList.toggle('is-active', (parseInt(b.getAttribute('data-tier'), 10) || 1) === state.tierMin); });
      var els = windowsWrap.querySelectorAll('.win');
      for (var i = els.length - 1; i >= 0; i--) els[i].remove();
      setCount(state.tierMin);
    }

    // ---- État initial : config sauvegardée si présente, sinon défauts ----
    var saved = loadSaved();
    if (saved && saved.unit && UNITS[saved.unit]) {
      state.unit = saved.unit;
      state.tierMin = saved.tierMin || 1;
      state.open = !!saved.open;
    } else {
      state.unit = defaultUnit;
      state.tierMin = defaultTier;
      state.open = defaultOpen;
    }
    // Reflète unité + palier dans les boutons.
    unitBtns.forEach(function (b) { b.classList.toggle('is-active', b.getAttribute('data-unit') === state.unit); });
    tierBtns.forEach(function (b) { b.classList.toggle('is-active', (parseInt(b.getAttribute('data-tier'), 10) || 1) === state.tierMin); });
    // Construit les windows (minimum du palier, ou plus si sauvegardé).
    var initialQty = state.tierMin;
    if (saved && saved.qty) initialQty = Math.max(state.tierMin, saved.qty);
    setCount(initialQty);
    // Restaure les valeurs de chaque window.
    if (saved && saved.windows && saved.windows.length) {
      var restoreEls = windowsWrap.querySelectorAll('.win');
      saved.windows.forEach(function (sw, i) { if (restoreEls[i]) restoreWindow(restoreEls[i], sw); });
      renumber();
      recompute();
    }
    ready = true;
  }

  /* =========================================================================
     BOOT
     ========================================================================= */
  function step() {
    var card = document.querySelector('[data-blinds-offer]');
    if (!card) return false;
    initMulti(card);
    return card.__multiInit === true;
  }

  function start() {
    if (step()) return;
    var tries = 0;
    var timer = setInterval(function () {
      tries++;
      if (step() || tries > 240) clearInterval(timer);
    }, 250);
    var target = document.querySelector('.product__info-container') || document.body;
    var obs = new MutationObserver(function () { if (step()) { clearInterval(timer); obs.disconnect(); } });
    obs.observe(target, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
